import { isset } from 'src/util/Util';

const mixinHandle = {
  methods: {
    handleChangeTypes() {
      switch (this.model.type) {
        case 'empresa':
          this.model.rate_farms_id = [];
          this.model.rate_lots_id = [];
          this.cleaRows();
          break;
        case 'finca':
          this.model.rate_lots_id = [];
          this.cleaRows();
          break;
        case 'lote':
          this.getLots();
          break;

        default:
          break;
      }
    },

    cleanRateTypes(removedId, modelToForEach, indexToClean) {
      removedId.forEach((id) => {
        modelToForEach.forEach((comparateId, index) => {
          if (comparateId === id) {
            indexToClean.forEach((element) => {
              this.$set(this.model[element], index, null);
              this.handleChange(index, element);
            });
          }
        });
      });
    },

    handleChangeBusinesses() {
      this.selectAllFromSelect('model.businesses_id', this.businesses);

      if (!isset(this.model.businesses_id)) this.clearAll();
      else {
        const removedId = this.getRemovedId(
          this.model.rate_businesses_id,
          this.model.businesses_id
        );

        this.cleanRateTypes(removedId, this.model.rate_businesses_id, [
          'rate_types_id',
          'rate_businesses_id',
          'rate_farms_id',
          'rate_lots_id',
        ]);
      }

      this.calculateAmountAvalible();
      this.filteredActivityrates;
      this.model.farms_id = [];
      this.model.lots_id = [];
      this.cleanRateTypes(
        [...this.model.rate_farms_id],
        [...this.model.rate_farms_id],
        ['rate_farms_id']
      );
      this.cleanRateTypes(
        [...this.model.rate_lots_id],
        [...this.model.rate_lots_id],
        ['rate_lots_id']
      );
    },

    handleChangeFarms() {
      this.selectAllFromSelect('model.farms_id', this.listFarmsByBusiness);
      const removedId = this.getRemovedId(
        this.model.rate_farms_id,
        this.model.farms_id
      );

      this.cleanRateTypes(removedId, this.model.rate_farms_id, [
        'rate_types_id',
        'rate_farms_id',
        'rate_lots_id',
      ]);

      this.getLots();
      this.calculateAmountAvalible();
      this.model.lots_id = [];
      this.cleanRateTypes(
        [...this.model.rate_lots_id],
        [...this.model.rate_lots_id],
        ['rate_lots_id']
      );
    },

    handleChangeLots() {
      this.selectAllFromSelect('model.lots_id', this.lots);
      const removedId = this.getRemovedId(
        this.model.rate_lots_id,
        this.model.lots_id
      );

      this.cleanRateTypes(removedId, this.model.rate_lots_id, [
        'rate_types_id',
        'rate_lots_id',
      ]);
      this.calculateAmountAvalible();
    },

    handleChangeRates(index) {
      this.handleChange(index, 'rate_types_id');
      this.validateRepeatRates(index, 'rate_types_id');
    },

    handleChangeRateBusinesses(index) {
      this.handleChange(index, 'rate_businesses_id');
      this.validateRepeatRates(index, 'rate_businesses_id');
      this.$set(this.model.rate_farms_id, index, null);
      this.$set(this.model.rate_lots_id, index, null);
      this.farmFilter(index);
    },

    handleChangeRateFarms(index) {
      this.handleChange(index, 'rate_farms_id');
      this.validateRepeatRates(index, 'rate_farms_id');
      this.$set(this.model.rate_lots_id, index, null);
    },

    handleChangeRateLots(index) {
      this.handleChange(index, 'rate_lots_id');
      this.validateRepeatRates(index, 'rate_lots_id');
    },

    getRemovedId(mainDataId, modelToVerify) {
      return mainDataId.filter(
        (id) => !modelToVerify.some((idToVerify) => idToVerify === id)
      );
    },

    getDataByOtherSelected(
      listOptions,
      mainDataId,
      modelToVerify,
      calculateAmount = [true, 1, ''],
      amount = null
    ) {
      const dataFiltered = listOptions.filter((option) => {
        if (modelToVerify) {
          return modelToVerify.includes(option.id);
        }

        return option;
      });

      if (mainDataId.length === 0) return dataFiltered;

      const amountByElement = dataFiltered
        .map((filteredOption) => filteredOption.id)
        .reduce((acc, id) => {
          const count = mainDataId.filter((item) => item === id).length;

          return {
            ...acc,
            [id]: count,
          };
        }, {});

      if (calculateAmount[0]) this.calculateAmountAvalible();
      const filtered = Object.keys(amountByElement).filter((element) => {
        if (calculateAmount[0]) {
          const secondParamToValidate =
            calculateAmount[1] === 1
              ? this.amountAvalible[1][element]
              : this.amountAvalible[0];

          if (
            Number(amountByElement[Number(element)]) === 0 ||
            amountByElement[Number(element)] < secondParamToValidate
          )
            return Number(element);
        } else {
          if (amountByElement[Number(element)] < amount) return Number(element);
        }
      });

      return dataFiltered.filter((filteredOption) => {
        if (calculateAmount[1] === 'farm') {
          return (
            filteredOption.businesses &&
            filteredOption.businesses.some(
              (item) => calculateAmount[2] === item.id
            ) &&
            (filtered.includes(String(filteredOption.id)) ||
              filtered.includes(filteredOption.id))
          );
        } else {
          return (
            filtered.includes(String(filteredOption.id)) ||
            filtered.includes(filteredOption.id)
          );
        }
      });
    },
  },
};

export default mixinHandle;
